import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '@/common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiLinkedin, FiTwitter, FiInstagram, FiFacebook, FiPhone } = FiIcons;

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const email = "info@melonedge.com";
  const phone = "(714) 794-8513";
  
  const socialLinks = [
    { icon: FiLinkedin, href: "https://www.linkedin.com/company/melonedge", label: "LinkedIn" },
    { icon: FiTwitter, href: "https://x.com/melonedgellc", label: "X" },
    { icon: FiInstagram, href: "https://www.instagram.com/melonedgellc", label: "Instagram" },
    { icon: FiFacebook, href: "https://www.facebook.com/melonedgellc", label: "Facebook" }
  ];

  return (
    <footer className="border-t border-slate-100 bg-white pt-20 pb-12">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="flex flex-col items-center">
          <div className="flex flex-col items-center text-center mb-12">
            <img 
              src="https://media-manager-c.questera.ai/greta-media/2f6847c5255962cb7ef6c818c843620d0179d6b0e810fa4ca1144f00d96707af10e5b2228b1b15861dc89ecefec6c49b/images/aW1hZ2UvanBlZw==/0e7b860b877a87f63ad4e70648eb81a8.jpg" 
              alt="MelonEdge" 
              className="h-7 w-auto object-contain mix-blend-darken grayscale opacity-40 mb-6" 
            />
            <p className="max-w-md text-sm text-slate-400 leading-relaxed font-medium mb-4">
              MelonEdge LLC • Huntington Beach, CA 92648
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-8">
              <a 
                href={`mailto:${email}`} 
                className="text-sm font-bold text-slate-600 hover:text-orange-600 transition-colors uppercase tracking-tight"
              >
                {email}
              </a>
              <span className="hidden sm:inline text-slate-200">|</span>
              <a 
                href={`tel:+17147948513`} 
                className="text-sm font-bold text-slate-600 hover:text-orange-600 transition-colors flex items-center gap-2 uppercase tracking-tight"
              >
                <SafeIcon icon={FiPhone} className="h-3.5 w-3.5 text-orange-500" />
                {phone}
              </a>
            </div>
          </div>

          <div className="flex gap-6 mb-12">
            {socialLinks.map((social) => (
              <a 
                key={social.label}
                href={social.href} 
                target="_blank" 
                rel="noopener noreferrer"
                className="h-10 w-10 flex items-center justify-center rounded-full bg-slate-50 text-slate-400 hover:bg-orange-500 hover:text-white transition-all transform hover:scale-110"
                aria-label={social.label}
              >
                <SafeIcon icon={social.icon} className="h-5 w-5" />
              </a>
            ))}
          </div>

          <div className="w-full border-t border-slate-50 pt-8 text-center">
            <p className="text-[10px] uppercase tracking-[0.2em] text-slate-300 font-bold">
              &copy; {currentYear > 2026 ? currentYear : 2026} MelonEdge LLC. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}